export default __webpack_public_path__ + "static/media/1931.99179216.png";